/* eslint-disable */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useContext } from 'react';
import { Form, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';

import { Context } from 'context/AuthContext';
import './styles.scss';

const FormLogin = () => {
  const params = new URLSearchParams(useLocation().search);

  const initialState = {
    username: '',
    password: '',
    redirect: params.get('urlReturn')
      ? decodeURIComponent(params.get('urlReturn'))
      : '/',
  };

  const [values, setValues] = useState(initialState);
  const [erroLogin, setErroLogin] = useState(false);
  const [erroLoginMessage, setErroLoginMessage] = useState(null);
  const { handleLogin } = useContext(Context);

  const date = new Date();

  function onChange(event) {
    const { value, name } = event.target;

    const clearName = name.split('_')[0];

    setValues({
      ...values,
      [clearName]: value,
    });
  }

  async function onSubmit(event) {
    event.preventDefault();

    const cleanValues = {
      username: DOMPurify.sanitize(values.username),
      password: DOMPurify.sanitize(values.password),
      redirect: DOMPurify.sanitize(values.redirect),
    }

    const res = await handleLogin(values);
    setErroLogin(!res.authenticated);
    if (res.error?.length > 0) {
      setErroLoginMessage(res.error);
    }
  }

  return (
    <div style={{ marginTop: '13px' }}>
      <label htmlFor="check">
        <FontAwesomeIcon icon={faBars} size="2x" />
      </label>

      <input type="checkbox" id="check" />

      <label htmlFor="check">
        <div className="turn-off-the-light" />
      </label>
      <Form onSubmit={(e) => onSubmit(e)}>
        <div className="form-login">
          <div>
            <label htmlFor="check">
              <FontAwesomeIcon icon={faTimes} size="1x" />
            </label>
          </div>
          <div>
            <Form.Group controlId="formLogin">
              <Form.Control
                type="email"
                autoComplete="off"
                placeholder="Login"
                name={'username_' + date.toJSON()}
                onChange={onChange}
              />
              {erroLogin && (
                <Badge pill variant="danger pl-2 pr-2 mt-1 mb-1">
                  <p className="mb-0 pb-0">
                    {erroLoginMessage || 'Nome de usuário ou senha incorreta.'}
                  </p>
                </Badge>
              )}
            </Form.Group>
          </div>
          <div>
            <Form.Group controlId="formPassword">
              <Form.Control
                type="password"
                autoComplete="off"
                placeholder="Senha"
                name="password"
                onChange={onChange}
              />
              <a href="/recuperar-senha">
                <b>Esqueceu sua senha?</b>
              </a>
            </Form.Group>
          </div>

          <div>
            <Button onClick={onSubmit} variant="primary" type="submit">
              Entrar
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default FormLogin;
